import { UserRole } from '../user-role';

import { UserBaseForm, UserBaseFormControls } from './user-base.form';
import { FormControl } from '@angular/forms';
import { SETTINGS_FORM_GROUP_NAME } from '../../constants';
import { UpsertUserData } from '../upsert-user';

export enum UserAccountManagerFormControls {
    TeamLeadId = 'teamLeadId'
}

export class UserAccountManagerForm extends UserBaseForm {
    constructor() {
        super();
    }

    initForm(): void {
        this.form.get(UserBaseFormControls.Role)?.setValue(UserRole.AccountManager, { emitEvent: false });
        this.form.addControl(UserAccountManagerFormControls.TeamLeadId, new FormControl(null), { emitEvent: false });
        this.form.addControl(SETTINGS_FORM_GROUP_NAME, new FormControl(null), { emitEvent: false });
    }

    override applyUserDetails(userDetails?: UpsertUserData) {
        super.applyUserDetails(userDetails);
    }
}
